import React from 'react'
import useFormatPrice from '@framework/product/use-price'
import fetcher from '@framework/fetcher'

export const usePriceWithOptionSelections = (options: {
  defaultPrice: number
  productId: number
  optionSelections?: (void | {
    option_id: string
    option_value: string
  })[]
}) => {
  const { defaultPrice, productId, optionSelections } = options
  const [price, setPrice] = React.useState(defaultPrice)

  React.useEffect(() => {
    const getAndUpdatePrice = async () => {
      const data = await fetcher({
        url: '/api/product/pricing',
        method: 'POST',
        body: { products: [{ productId, options: optionSelections }] },
      })
      setPrice(data.productPrices[productId])
    }
    getAndUpdatePrice()
  }, [optionSelections])

  const { price: formattedPrice } = useFormatPrice({
    amount: price,
    baseAmount: price,
    currencyCode: 'USD',
  })

  return { price: formattedPrice }
}
